import {createContext} from 'react'

export type AccordionType = 'single' | 'multiple'
export type AccordionChevronPlacement = 'leading' | 'trailing'

/**
 * Per-accordion presentation options. Private: never exported from the package barrel.
 */
export interface AccordionConfig {
  chevronPlacement: AccordionChevronPlacement
}

/** Stable handles, kept apart from `AccordionConfig` so they never re-render on an option change. */
export interface AccordionActions {
  /**
   * Idempotent group-state writer. Always takes the *next* open state for a value
   * rather than toggling, so repeated `beforematch` reveals of an already-open item
   * cannot close it.
   */
  setItemOpen: (value: string, nextOpen: boolean) => void
}

export interface AccordionItemState {
  value: string
  disabled: boolean
}

export const AccordionConfigContext = createContext<AccordionConfig | null>(null)

export const AccordionActionsContext = createContext<AccordionActions | null>(null)

/** Dynamic group state, split out so config consumers do not re-render on every open/close. */
export const AccordionStateContext = createContext<ReadonlySet<string> | null>(null)

export const AccordionItemContext = createContext<AccordionItemState | null>(null)
